//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ref, onMounted } from '@vue/composition-api'
import { useRouter } from '@core/utils'
import { info } from '@core/utils/toasted'
import themeConfig from '@themeConfig'
import useCryptoJs from '@core/utils/useCryptoJs'
import useLogData from '@core/utils/useLogData'
import {
  addUserUploadAvatar,
} from '@api'
import store from '@/store'

import AppBarUserAvatar from '@core/layouts/components/app-bar/AppBarUserAvatar.vue'

export default {
  components: {
    AppBarUserAvatar,
  },
  setup() {
    const { userData } = useCryptoJs()
    const { route, router } = useRouter()
    const { logData, updateLogData } = useLogData()

    const privateLanding = ref(null)
    const userLogged = ref(null)
    const matchCode = ref(null)

    const refInputEl = ref(null)
    const urlImage = ref(null)
    const imageData = ref(null)

    // remove team
    const teamSelected = ref(null)

    const onLogin = async () => {
      logData.value.joinGame = 'NO'
      logData.value.matchCode = matchCode.value
      logData.value.redirect = 'landing'
      logData.value.field = 'all'
      logData.value.date = 'all'
      logData.value.time = 'all'

      // remove team
      logData.value.team = teamSelected.value
      await updateLogData(logData.value)

      router.push({ name: 'auth-login-phone-email' })
    }

    const goToPayBooking = () => {
      router.replace({
        name: 'match',
        params: {
          code: route.value.params.code,
          joined: route.value.params.joined,
          joinedMessage: route.value.params.joinedMessage,
          joinedFrom: route.value.params.joinedFrom,
          team: route.value.params.team,
        },
      })
    }

    const initView = async () => {
      userLogged.value = await JSON.parse(localStorage.getItem('userData'))
      privateLanding.value = !!userLogged.value
      const { code, team } = route.value.params
      matchCode.value = code
      teamSelected.value = `${team}`.toUpperCase()
    }

    const onLogout = async () => {
      await localStorage.removeItem('userData')
      privateLanding.value = false

      await initView()
    }

    const onContinue = async () => {
      if (userLogged.value) {
        if (imageData.value) {
          const formData = new FormData()
          formData.append('file', imageData.value)
          const responseLogo = await addUserUploadAvatar(formData)

          if (responseLogo.ok) {
            await localStorage.setItem('userAvatar', JSON.stringify(responseLogo.data))
            await store.commit('auth/UPDATE_USER_AVATAR', responseLogo.data)

            goToPayBooking()
          }
        } else {
          goToPayBooking()
        }
      } else {
        onLogin()
      }
    }

    const cleanImage = () => {
      imageData.value = null
      urlImage.value = null
    }

    const convertBlobToFile = (blob, fileName = 'file') => {
      const selectedFile = new File([blob], fileName, { type: blob.type })
      cleanImage()
      if (selectedFile && selectedFile.size >= 25000000) info('Max size of 25MB!')
      const type = selectedFile ? selectedFile.type.split('/').pop() : null
      if (selectedFile && (['jpg', 'png', 'jpeg'].includes(type)) && selectedFile.size < 25000000) {
        imageData.value = selectedFile
        if (selectedFile) {
          urlImage.value = URL.createObjectURL(imageData.value)
        }

        if (imageData.value) {
          // dataComputed.value.imageData = imageData.value
          // emit('updateEditAvatar', dataComputed.value)
          // action
        }
      } else {
        cleanImage()
      }
    }

    const compressAgain = (blob, name) => {
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      const img = new Image()
      img.src = URL.createObjectURL(blob)
      img.onload = () => {
        const { width } = img
        const { height } = img

        canvas.width = width
        canvas.height = height
        ctx.drawImage(img, 0, 0, width, height)

        canvas.toBlob(newBlob => {
          convertBlobToFile(newBlob, name)

          // Aquí puedes manejar el nuevo blob comprimido
        }, 'image/jpeg', 0.5) // Disminuir calidad para reducir tamaño
      }
    }

    const compressImage = file => {
      const reader = new FileReader()
      reader.onload = e => {
        const img = new Image()
        img.src = e.target.result
        img.onload = () => {
          const canvas = document.createElement('canvas')
          const ctx = canvas.getContext('2d')
          const MAX_WIDTH = 512
          const MAX_HEIGHT = 512

          let { width } = img
          let { height } = img

          // Calcula la nueva dimensión manteniendo la relación de aspecto
          if (width > height) {
            height *= MAX_WIDTH / width
            width = MAX_WIDTH
          } else {
            width *= MAX_HEIGHT / height
            height = MAX_HEIGHT
          }

          canvas.width = width
          canvas.height = height
          ctx.drawImage(img, 0, 0, width, height)

          // Comprimir la imagen a menos de 1MB
          canvas.toBlob(blob => {
            if (blob.size > 1024 * 1024) {
              // Si el tamaño es mayor a 1MB, comprimir más
              compressAgain(blob, file.name)
            } else {
              convertBlobToFile(blob, file.name)

              // Aquí puedes manejar el blob resultante (subir, etc.)
            }
          }, 'image/jpeg', 0.7) // Ajusta la calidad según sea necesario
        }
      }
      reader.readAsDataURL(file)
    }

    const onFileSelected = e => {
      if (e.target.files.length) {
        try {
          const selectedFile = e.target.files[0]
          compressImage(selectedFile)
        } catch (error) {
          console.error('error', error)
        }
      }
    }

    onMounted(async () => {
      await initView()
    })

    return {
      privateLanding,
      matchCode,
      userData,
      userLogged,

      refInputEl,
      urlImage,
      imageData,

      // remove team
      teamSelected,

      // methods
      onLogin,
      onLogout,
      onContinue,
      onFileSelected,
      goToPayBooking,

      // themeConfig
      logoProfileEmpty: themeConfig.app.logoProfileEmpty,

      icons: {
        level: require('@/assets/images/svg/level.svg'),
      },
    }
  },
}
